import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
      width: '100%',
      minHeight: 144,
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        gap: Spacings.s6,
      },
    },
    label: {
      fontSize: FontSizes.t4,
      lineHeight: LineHeights.t4,
      fontWeight: FontWeights.semibold,
      color: TextColors.base,
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        fontSize: FontSizes.t3,
        lineHeight: LineHeights.t3,
      },
    },
    hidden: {
      display: 'none',
    },
  },
  { name: 'upload-area' }
);

export default useStyles;
